import builder from '../builder';
import CopyPaste from '../../streamline-icons/bold/copy-paste.svg';

export default builder('IconCopyPasteBold', CopyPaste);
